import * as React from 'react';
import { Modal, MessageBoxFunctionalLayout, Text, Box, Loader, } from 'wix-style-react';
import { translate } from 'react-i18next';
var ApproveDeleteContacts = function (props) {
    var numberOfContacts = props.numberOfContacts, isOpen = props.isOpen, t = props.t, onCancel = props.onCancel, onApprove = props.onApprove, isLoading = props.isLoading;
    var renderLoader = function () { return (React.createElement(Box, null,
        React.createElement(Loader, { size: "tiny" }))); };
    var isPlural = numberOfContacts > 1;
    return (React.createElement(Modal, { isOpen: isOpen },
        React.createElement(MessageBoxFunctionalLayout, { title: isPlural
                ? t('deleteModalHeaderMultiple')
                : t('deleteModalHeaderSingle'), onOk: onApprove, onCancel: onCancel, onClose: onCancel, confirmText: t('deleteModalConfirm'), confirmPrefixIcon: isLoading && renderLoader(), disableCancel: isLoading, disableConfirmation: isLoading, cancelText: t('deleteModalCancel'), theme: "red", dataHook: "delete-contact-modal" },
            React.createElement(Box, { direction: "vertical" },
                React.createElement(Box, null,
                    React.createElement(Text, { dataHook: "delete-contact-modal-body" }, isPlural
                        ? t('delete.modal.body.body.multiple', {
                            amount: numberOfContacts,
                        })
                        : t('delete.modal.body.body.single'))),
                React.createElement(Box, { marginTop: 4 },
                    React.createElement(Text, { dataHook: "delete-contact-modal-warning" }, isPlural
                        ? t('delete.modal.body.warning.multiple', {
                            amount: numberOfContacts,
                        })
                        : t('delete.modal.body.warning.single')))))));
};
export var ApproveDeleteContactsModal = translate()(ApproveDeleteContacts);
//# sourceMappingURL=ApproveDeleteContactsModal.js.map